import { loadable } from '@capillarytech/cap-ui-utils';
import * as path from '../../../config/path';

const { publicPath } = path;

const routes = [
  {
    exact: true,
    path: `${publicPath}`,
    type: 'dashboard',
    component: loadable(() => import('../Dashboard')),
  },
  {
    path: `${publicPath}/settings`,
    type: 'badgesSetting',
    component: loadable(() => import('../BadgesSettings')),
  },
  {
    exact: true,
    path: `${publicPath}/not-enabled`,
    component: loadable(() => import('../BadgesNotEnabled')),
  },
  {
    exact: true,
    path: `${publicPath}/:badgeId/view`,
    type: 'badgesList',
    component: loadable(() => import('../Dashboard')),
  },
  {
    exact: true,
    path: `${publicPath}/accessForbidden`,
    type: 'authenticationFlow',
    component: loadable(() => import('../AccessForbidden')),
  },
];

export default routes;
